import Compressor from "compressorjs";
import { API_URL, END_POINTS } from "../constants/urls";
import { getFromStorage } from "../helpers/storage";
import { STORAGE_KEYS } from "../constants";
// import { media_url } from "../helpers/constants/urls";

interface UploadResponse {
  statusCode: number;
  status: number;
  code: number;
  data: any;
  message: string;
}

export const UploadMedia = (imageFile: File): Promise<UploadResponse> => {
  return new Promise((resolve, reject) => {
    new Compressor(imageFile, {
      quality: 0.6,
      success: async (compressedResult: Blob) => {
        const formData = new FormData();
        formData.append("file", compressedResult);
        formData.append("type", "1");

        try {
          const token = await getFromStorage(STORAGE_KEYS.token);
          const headers = new Headers({
            "Accept-Language": "en",
            "x-portal": "admin",
            "x-device-type": "WEB",
            Device: "WEB",
            Authorization: String(token),
          });

          const response = await fetch(`${API_URL}${END_POINTS.upload}`, {
            method: "POST",
            headers,
            body: formData,
          });

          const result: UploadResponse = await response.json();
          console.log("UploadMedia response:", result);
          resolve(result);
        } catch (error) {
          console.error("UploadMedia error:", error);
          reject(error);
        }
      },
      error: (compressionError: any) => {
        console.error("Compression error:", compressionError);
        reject(compressionError);
      },
    });
  });
};
